import { Injectable } from '@angular/core';
import {
  ISensorHumedadSuelo,
  IQueryParam,
  ICliente,
  IBombaSumergible,
  ICreateBombaSumergible,
  IUpdateBombaSumergible,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { apiBase } from 'src/environments/environment';
import { HelperService } from '../../../auxiliares/helper.service';
import { HttpService } from '../../../auxiliares/http.service';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class SumergiblesService {
  constructor(private http: HttpService) {}

  public getByid(id: string): Observable<IBombaSumergible> {
    return this.http.get(`${api}/bombasumergibles/${id}`);
  }
  public getFiltered(queryParams?: IQueryParam): Observable<{
    data: IBombaSumergible[];
    total: number;
  }> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/bombasumergibles`, { params });
  }
  public create(data: ICreateBombaSumergible): Observable<IBombaSumergible> {
    return this.http.post(`${api}/bombasumergibles`, data);
  }
  public update(
    id: string,
    data: IUpdateBombaSumergible,
  ): Observable<IBombaSumergible> {
    return this.http.put(`${api}/bombasumergibles/${id}`, data);
  }
  public delete(id: string): Observable<IBombaSumergible> {
    return this.http.delete(`${api}/bombasumergibles/${id}`);
  }

  public encender(id: string): Observable<void> {
    return this.http.post(`${api}/comandos/bombaSumergibles/encender`, { id });
  }

  public apagar(id: string): Observable<void> {
    return this.http.post(`${api}/comandos/bombaSumergibles/apagar`, { id });
  }

  // Reportes

  public async exportarReportes(
    queryParams?: IQueryParam,
    filename = 'reportes.xlsx',
  ): Promise<void> {
    const params = HelperService.getQueryParams(queryParams);
    await this.http.getFile(`${api}/reportes/exportar/shs`, filename, params);
  }

  // Parseos

  public estadoShs(dato: ISensorHumedadSuelo) {
    const limite = this.fechaHaceXHoras(6);
    const ultimaComunicacion = dato.ultimaComunicacion
      ? new Date(dato.ultimaComunicacion)
      : null;

    if (!ultimaComunicacion || limite > ultimaComunicacion) {
      return 'Sin reportar';
    }

    return dato.ultimoEstado;
  }

  private fechaHaceXHoras(horas: number) {
    const fecha = new Date();
    fecha.setHours(fecha.getHours() - horas);
    return fecha;
  }

  public conseguidorDeColoresPorShs(
    shs: ISensorHumedadSuelo,
    cliente?: ICliente,
  ): string | undefined {
    const tempActual = shs.ultimoReporte?.reporte?.temperatura;

    const semaforos =
      shs?.configuraciones?.coloresNivel ||
      cliente?.configuraciones?.cisterna?.coloresNivel;

    const find = semaforos?.find((semaforo) => {
      return (
        tempActual! >= semaforo.valorDesde && tempActual! < semaforo.valorHasta
      );
    });
    return find?.color;
  }
}
